import styles from './TrialBanner.module.css';

const TERMS = ['7 days', '30 verified leads', 'verify 125', 'enrich 50', 'no credit card'];

export default function TrialBanner() {
  return (
    <div className={styles.banner}>
      <div className={styles.inner}>
        <span className={styles.tag}>Free trial</span>
        <ul className={styles.terms}>
          {TERMS.map((t) => <li key={t}>{t}</li>)}
        </ul>
      </div>
    </div>
  );
}
